/* eslint-disable ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class ItemRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    let year = moment().format('YYYY');

    return hash({
      ledgerItem: this.store.findRecord('finance/ledger-item', params.item_id),
      lineItems: this.store.query('finance/line-item', {
        ledgerItemId: params.item_id,
        include: 'accounts',
      }),
      // Transactions are used to calculate "refundable amounts".
      transactions: this.store.query('finance/transaction', {
        ledgerItemId: params.item_id,
      }),
      // Groups are used for filtering
      groups: this.store.query('group', { year }),
    });
  }

  setupController() {
    super.setupController(...arguments);
    this.controller.set(
      'hideArchivedLineItems',
      this.controller.get('personOptions.hideArchivedLineItems'),
    );
  }
}
